import type { Paginated, PaginationQuery } from "@/configs/request";
import type { PromoCode, PromoCodeKind } from "@/types";

import { BaseApi } from "./base.api";

export interface CreatePromoCodePayload {
  code: string;
  kind?: PromoCodeKind;
  coffees: number;
  maxUses?: number | null;
  perUserLimit?: number;
  startsAt?: string | null;
  endsAt?: string | null;
  note?: string | null;
}

/**
 * Tahrirlashda `code`, `kind` va `coffees` YO'Q.
 *
 * Ular allaqachon tarqatilgan va'da: kodni yoki uning qiymatini
 * o'zgartirish odamlar qo'lidagi qog'ozni yolg'onga chiqarardi.
 * Kampaniyani to'xtatish uchun `enabled`, uzaytirish uchun `endsAt`.
 */
export interface UpdatePromoCodePayload {
  enabled?: boolean;
  maxUses?: number | null;
  endsAt?: string | null;
  note?: string | null;
}

class AdminPromoApi extends BaseApi {
  list(query: PaginationQuery = {}) {
    return this.request<Paginated<PromoCode>>("/admin/promo-codes", { query: { ...query } });
  }

  create(payload: CreatePromoCodePayload) {
    return this.request<PromoCode>("/admin/promo-codes", { method: "POST", body: payload });
  }

  update(id: string, payload: UpdatePromoCodePayload) {
    return this.request<PromoCode>(`/admin/promo-codes/${id}`, {
      method: "PATCH",
      body: payload,
    });
  }
}

export const adminPromoApi = new AdminPromoApi();
